module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.modes), function(o) {
    return _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "box-container is-flex fdc jcc aic"
    }, [_c('div', {
      staticClass: "element-box-container text-only",
      on: {
        "click": function($event) {
          return _vm.select(o.code)
        }
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.name))])]), _c('div', {
      staticClass: "box-explanation"
    }, [_c('span', [_vm._v(_vm._s(o.description))])])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-hidden-tablet-only is-hidden-desktop-only is-hidden-widescreen-only is-hidden-fullhd"
  }, [_c('br'), _c('div', {
    staticClass: "feature-helvetica fs-18"
  }, [_c('span', [_vm._v(" Our ")]), _c('span', {
    staticClass: "w400"
  }, [_vm._v("Guided Setup")]), _c('span', [_vm._v(" is a tool for using well known third party mining apps with our platform.")])]), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-title"
  }, [_c('span', [_vm._v("Select your setup mode")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de710d9","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/get_started/c_step_mode.vue
// module id = 368
// module chunks = 1